module.exports = "//public.zight.com/packs/media/images/icons-notifications-active-3cd2a48078afc86b416e389414aa3863.svg";